import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { OutsidePageWrapper } from "@parkschannel/ui";
import { OurCreatorsSection } from "./OurCreatorsSection";
import { BecomeCreatorCTASection } from "./BecomeCreatorCTASection";
import { BecomeCreatorCover } from "./BecomeCreatorCover";
import { useButtonsAnalytics } from "../../../utils";
export const BecomeCreatorPage = ()=>{
    useButtonsAnalytics();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(OutsidePageWrapper, {
                children: /*#__PURE__*/ _jsx(BecomeCreatorCover, {})
            }),
            /*#__PURE__*/ _jsx(BecomeCreatorCTASection, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "pb-5",
                children: /*#__PURE__*/ _jsx(OurCreatorsSection, {})
            })
        ]
    });
};
